import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import ResearchTracks from "./components/ResearchTracks";

function App() {
  return (
    <div className="relative">
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/research" element={<ResearchTracks />} />
      </Routes>
    </div>
  );
}

export default App;
